import React from 'react';
import ArrowToRight from 'material-ui/svg-icons/navigation/arrow-forward';

export default function TransferAll({ multiTransfer, id }) {
    return (
        <div id={id}>
            <ArrowToRight 
                style={{ cursor: 'pointer' }}
                onClick={multiTransfer}
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/Vessels/Composition/TransferAll.jsx